import React from "react";
import { Alert, Box, Button, CircularProgress } from "@mui/material";

const PushActions = ({
  onBack,
  onPush,
  pushing,
  readyCount,
  disabled,
  errorMessage
}) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
    <Button variant="outlined" onClick={onBack} disabled={pushing}>
      Back to Conflicts
    </Button>

    <Box display="flex" gap={2} alignItems="center">
      {errorMessage && <Alert severity="error" sx={{ mr: 2 }}>{errorMessage}</Alert>}
      <Button
        variant="contained"
        color="success"
        size="large"
        disabled={disabled}
        onClick={onPush}
        startIcon={pushing ? <CircularProgress size={20} /> : null}
      >
        {pushing ? "Pushing to Database..." : `Push ${readyCount} Bars to Database`}
      </Button>
    </Box>
  </Box>
);

export default PushActions;
